import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './styles';

export const ReatendimentoAtendente = () => {
  const protocolos = useSelector(state => state.formulario.protocoloReatendimento);

  return (
    <div>
      <S.Label>
        Existem <b>{protocolos?.length}</b> requerimentos com status de <b>Reatendimento</b>, disponíveis para
        atendimento na sua lista. Para visualizar o requerimento, basta pesquisar pelo número de protocolo a seguir:
        <br />
      </S.Label>
      {protocolos?.map(numProtocolo => {
        return <p key={numProtocolo}>{numProtocolo}</p>;
      })}
    </div>
  );
};

export default ReatendimentoAtendente;
